<ion-header>
  <ion-toolbar>
    <ion-title>{{item.bezeichnung}}</ion-title>
  </ion-toolbar>
</ion-header>

<!-- SNIPPET:START:Content -->
<ion-content>
  <ion-card class="artikel">
    <img [src]="item.bildUrl" [class.small]="small" (click)="toggleSmall()" *ngIf="item.bildUrl.indexOf('View.aspx') === -1" style="object-fit: contain;" />
    <ion-card-content *ngIf="config.zeigeDetailsInDetailfenster" style="padding: 0; margin: 0;">
      <ion-row style="font-size: small; padding: 0; margin: 0;">
        <ion-col size="6" >{{item.zusatz}}</ion-col>
        <ion-col size="6" style="text-align: right;" >{{item.ean}}</ion-col>
      </ion-row>
      <ion-row style="padding: 0; margin: 0;" *ngIf="item.zusatz2">
        <ion-col size="12" ><span style="font-size: small; font-style: italic;">{{item.zusatz2}}</span></ion-col>
      </ion-row>
      <ion-row class="header" style="padding: 0; margin: 0;">
        <ion-col size="3" >Vpe</ion-col>
        <ion-col size="3" >Topf</ion-col>
        <ion-col size="3" >Höhe</ion-col>
        <ion-col size="3" *ngIf="!isInfo">Preis €</ion-col>
      </ion-row>
      <ion-row class="details" style="padding: 0; margin: 0;">
        <ion-col size="3" >{{item.vpe}}</ion-col>
        <ion-col size="3" >{{item.topfCm}}</ion-col>
        <ion-col size="3" >{{item.hoeheCm}}</ion-col>
        <ion-col size="3" style="font-weight: bold;" *ngIf="!isInfo && item.preisAnzeigen">{{item.vkPreisVe.toFixed(2).replace('.', ',')}}</ion-col>
      </ion-row>
    </ion-card-content>
  </ion-card>
</ion-content>
<!-- SNIPPET:END -->

<ion-footer style="background-color: var(--ion-background-color);">
  <ion-list *ngIf="item.verfuegbar && !isInfo">
    <!-- SNIPPET:START:Einheiten -->
      <ion-item>
        <ion-label position="stacked">Einheiten</ion-label>
        <ion-input #inputEh [style.backgroundColor]="config.inputHintergrundFarbe" appSelectOnClick (keydown)="toHinweis($event)" [maxlength]="item.maxEh.toString().length" [class.number]="true" type="number" [(ngModel)]="eh" min="0" [max]="item.maxEh" (ngModelChange)="ehChanged()" ></ion-input>
      </ion-item>
  
    <!-- SNIPPET:END -->
    <ion-item>
      <ion-label position="stacked" style="margin-bottom: 6px;">Bemerkung zum Artikel</ion-label>
      <ion-input #inputHinweis [style.backgroundColor]="config.inputHintergrundFarbe" appSelectOnClick (keydown)="ggfBestellen($event)" [(ngModel)]="hinweis" maxlength="100"></ion-input>
    </ion-item>
  </ion-list>
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-button (click)="bestellen()" *ngIf="item.verfuegbar" expand="full">
          <ion-icon slot="start" name="checkmark"></ion-icon>
          Ok
        </ion-button>
        <ion-button (click)="schliessen()" *ngIf="!item.verfuegbar" expand="full">
          <ion-icon slot="start" name="close"></ion-icon>
          Schließen
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
  
